import React from 'react';

import { LoadingOutlined } from '@ant-design/icons';

import StatusCell from '../../../components/Badge/StatusCell';
import BAConfirmDriverIcon from '../../../components/Icons/BAConfirmDriverIcon';
import BADriverInfoIcon from '../../../components/Icons/BADriverInfoIcon';
import BARejectDriverIcon from '../../../components/Icons/BARejectDriverIcon';
import ShieldIcon from '../../../components/Icons/ShieldIcon';
import RejectionIssuesModal from '../../../components/Modal/ModalActions/RejectionIssuesModal/RejectionIssuesModal';
import VerifyNINModal from '../../../components/Modal/ModalActions/VerifyNINModal/VerifyNINModal';
import Table from '../../../components/Table/Table';
import ActionRow from '../../../components/Table/TableAccessories/ActionRow';
import ActionRowWithModal from '../../../components/Table/TableAccessories/ActionRowWithModal';
import TableDateFormatter from '../../../components/Table/TableAccessories/TableDateFormatter';
import TableFirstAndLastNameFormatter from '../../../components/Table/TableAccessories/TableFirstAndLastNameFormatter';
import TableImageModal from '../../../components/Table/TableAccessories/TableImageModal';
import ViewDetails from '../../../components/Table/TableAccessories/ViewDetails';
import BAFilterForm from '../../../components/Table/TableFilterForms/BAFilterForm';
import ViewBADriverInfoCell from '../../../components/Table/TableMobileRowCell/ViewBADriverInfoCell';
import ViewBADriverInfoCompany from '../../../components/Table/TableSliderViews/ViewBADriverInfoCompany';
import useBaConfirmDriverProfile from '../../../hooks/dashboard/BaDriverVerification/useBaConfirmDriverProfile';

const CompanyInfoTable = () => {
  const { confirmDriverProfile, loading: confirmLoading } =
    useBaConfirmDriverProfile();

  return (
    <Table
      tableTitle='COMPANY INFO LIST'
      tableFilterBoxFeatures={{
        showSearchBox: true,
        searchBoxPlaceholder: 'Search',
        rightAttr: [
          {
            type: 'filter',
            comp: <BAFilterForm />,
          },
          // {
          //   type: 'regular',
          //   comp: <ExportBaData />,
          // },
        ],
      }}
      tableHeader={{
        'Date Submitted': 'dateUploaded',
        'Company Name': 'companyName',
        'Driver Name': 'driverName',
        NIN: 'nin',
        DOB: 'dateOfBirth',
        'Driver Image': 'driverImage',
        'Processing Status': 'status',
      }}
      tableDataSourceUrl='ba/v1/drivers/verification'
      cellsCustomComp={{
        dateUploaded: <TableDateFormatter dataKey='dateUploaded' />,
        status: <StatusCell statusKey='status' hasDot />,
        firstName: (
          <TableFirstAndLastNameFormatter
            firstNameDataKey='firstName'
            lastNameDataKey='lastName'
          />
        ),
        driverImage: <TableImageModal dataKey='driverImage' />,
      }}
      moreOptionsComponents={[
        <ViewDetails
          key='View driver profile'
          label='View driver profile'
          width='200px'
          icon={<BADriverInfoIcon />}
          sliderCompFn={(data: any) => <ViewBADriverInfoCompany data={data} />}
          conditionalRenderFn={(data: any) => data?.status === 'Pending'}
        />,
        <ActionRow
          key='Confirm profile'
          label='Confirm profile'
          width='200px'
          icon={confirmLoading ? <LoadingOutlined /> : <BAConfirmDriverIcon />}
          actionFn={async (data: any) => confirmDriverProfile(data?.id)}
          freshTable={true}
          conditionalRenderFn={(data: any) => data?.status !== 'Pending'}
        />,
        <ActionRowWithModal
          key='Reject profile'
          label='Reject profile'
          width='200px'
          icon={<BARejectDriverIcon />}
          modalCompFn={(data) => <RejectionIssuesModal data={data} />}
          // actionFn={async (data: any) => rejectDriverProfile(data?.id)}
          // freshTable={true}
          conditionalRenderFn={(data: any) => data?.status !== 'Pending'}
        />,
        // <ActionRowWithModal
        //   key='Indicate issue'
        //   label='Indicate issue'
        //   width='200px'
        //   icon={<ExclaimIcon />}
        //   modalCompFn={(data) => <IndicateIssuesModal data={data} />}
        //   conditionalRenderFn={(data: any) => data?.status === 'Pending'}
        // />,
        <ActionRowWithModal
          key='Confirm NIN'
          label='Confirm NIN'
          width='200px'
          icon={<ShieldIcon />}
          modalCompFn={(data) => <VerifyNINModal data={data} />}
          conditionalRenderFn={(data: any) => data?.status !== 'Pending'}
        />,
      ]}
      mobileCellComp={<ViewBADriverInfoCell />}
    />
  );
};

export default CompanyInfoTable;
